// Importando os módulos necessários do React Router
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// Importando todos os componentes utilizados nas rotas
import Home from './home/home';
import Login from './login/login';
import Controle from './ci/controle';
import GerarProcesso from './gerarProcesso/gerarProcesso';
import Comprovante from './comprovante/comprovante';
import RelatorioCliente from './relatorios/relatorioCliente';
import Suporte from './suporte/suporte';
import NoMatch from './noMatch/noMatch';
import Editor from './pagamentos/editor';
import Perfil from './perfil/perfil';
import Charts from './charts/chart';
import CreateUser from './createUser/createUser';
import Clientes from './clientes/clientes';
import Usuarios from './usuarios/usuarios';
import EditarUsuarios from './usuarios/editarUsuarios';
import Pessoas from './pessoas/pessoas';
import GestaoEmails from './gerenciarEmails/gerenciarEmails';

// Componente principal da aplicação
function App() {
  return (
    <div className="wrapper">
      <BrowserRouter>
        <Routes>
          {/* Rota pública: Página de Login */}
          <Route path="login" element={<Login />} />

          {/* Rotas protegidas: Requer autenticação */}
          <Route path="/" element={<Home />}>
            {/* Rota padrão (index) */}
            <Route index element={<Controle />} />

            {/* Rotas aninhadas sob o componente Home */}
            <Route path="ci/controle" element={<Controle />} />
            <Route path="ci/novo/processo" element={<GerarProcesso />} />
            <Route path="comprovantes" element={<Comprovante />} />
            <Route path="relatorios" element={<RelatorioCliente />} />
            <Route path="suporte" element={<Suporte />} />
            <Route path="ci/pagamentos/:id" element={<Editor />} />
            <Route path="perfil" element={<Perfil />} />
            <Route path="charts" element={<Charts />} />
            <Route path="cadastrar/usuario" element={<CreateUser />} />
            <Route path="consultar/clientes" element={<Clientes />} />
            <Route path="consultar/usuarios" element={<Usuarios />} />
            <Route path="usuario/:id" element={<EditarUsuarios />} />
            <Route path="consultar/pessoas" element={<Pessoas />} />
            <Route path='gerenciar-emails' element={<GestaoEmails />}/>

            {/* Rota para caminhos não correspondentes */}
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
